<template>
  <div class="foot">
    豫ICP备17049494号-1 <br>
    Powered by {{dateYear}} 汽车出口价
  </div>
</template>

<script>
    export default {
        name: "my-footer",
      data() {
        return {
          dateYear : ''
        }},
      mounted() {
          this.dateYear = this.dateFormat("YYYY", new Date());
      },
      methods:{
        dateFormat(fmt, date) {
          let ret;
          const opt = {
            "Y+": date.getFullYear().toString(),        // 年
            "m+": (date.getMonth() + 1).toString(),     // 月
            "d+": date.getDate().toString(),            // 日
            "H+": date.getHours().toString(),           // 时
            "M+": date.getMinutes().toString(),         // 分
            "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
          };
          for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
              fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
          }
          return fmt;
        }
      }
    }
</script>

<style scoped>
.foot{
  text-align: center;
  color: rgba(148, 146, 167, 1);
  font-size: 12px;
  background-color: rgba(30, 39, 62, 1);
}
</style>
